<template>
    <div class="field-container">

            <!-- Prepend HTML -->
            <div v-if="this.field.prependHtml != ''">
                {{ this.field.prependHtml }}
            </div>

            <!-- Not editable -->
            <div v-if="this.field.displayType == 'notEditable'">
                <ies-input-disabled :field="this.field"></ies-input-disabled>
            </div>

            <!-- Text box -->
            <div v-if="this.field.displayType == 'text'">
               <ies-input-text :field="this.field"></ies-input-text>
            </div>

            <!-- Standard html input -->
            <div v-if="this.field.displayType == 'htmlinput'">
                <ies-input-htmlinput :field="this.field"></ies-input-htmlinput>
            </div>

            <!-- Text area -->
            <div v-if="this.field.displayType == 'textarea'">
                <ies-input-textarea :field="this.field"></ies-input-textarea>
            </div>

            <!-- Email -->
            <div v-if="this.field.displayType == 'email'">
                <ies-input-email :field="this.field"></ies-input-email>
            </div>

            <!-- Integer -->
            <div v-if="this.field.displayType == 'integer'">
                <ies-input-integer :field="this.field"></ies-input-integer>
            </div>

            <!-- Hotel Facility Display Group -->
            <div v-if="this.field.displayType == 'displaygroup'">
                <ies-input-displaygroup :field="this.field"></ies-input-displaygroup>
            </div>

            <!-- Hotel Facility Category (e.g. in room, dining, activity etc -->
            <div v-if="this.field.displayType == 'facility_categories'">
                <ies-input-facilitycategories :field="this.field"></ies-input-facilitycategories>
            </div>

            <!-- Facility ID -->
            <div v-if="this.field.displayType == 'facilitykey'">
                <ies-input-facilitykey :field="this.field"></ies-input-facilitykey>
            </div>

            <!-- Hotel ID -->
            <div v-if="this.field.displayType == 'hotelkey'">
                <ies-input-hotelkey :field="this.field" :page="this.page"></ies-input-hotelkey>
            </div>

            <!-- Hotel Room ID -->
            <div v-if="this.field.displayType == 'hotelRoomKey'">
                <ies-input-hotelroomtypekey :field="this.field"></ies-input-hotelroomtypekey>
            </div>

            <!-- Tagging Keyword -->
            <div v-if="this.field.displayType == 'keywordKey'">
                <ies-input-keyword :field="this.field"></ies-input-keyword>
            </div>

            <!-- Hotel Rate Type ID -->
            <div v-if="this.field.displayType == 'rateTypeKey'">
                <ies-input-ratetypekey :field="this.field"></ies-input-ratetypekey>
            </div>

            <!-- Region ID -->
            <div v-if="this.field.displayType == 'regionkey'">
                <ies-input-regionkey :field="this.field"></ies-input-regionkey>
            </div>

            <!-- Region Hierarchy -->
            <div v-if="this.field.displayType == 'regionHierarchy'" >
                <ies-input-regionhierarchy :field="this.field"></ies-input-regionhierarchy>
            </div>

            <!-- Country Key -->
            <div v-if="this.field.displayType == 'countrykey'" >
                <ies-input-countrykey :field="this.field"></ies-input-countrykey>
            </div>

            <!-- Channel Manager ID -->
            <div v-if="this.field.displayType == 'channelManagerkey'" >
                <ies-input-channelmanagerkey :field="this.field"></ies-input-channelmanagerkey>
            </div>

            <!-- Channel Manager Configuration -->
            <div v-if="this.field.displayType == 'channelManagerConfig'">
                <ies-input-channelmanagerconfig :field="this.field"></ies-input-channelmanagerconfig>
            </div>

            <!-- Channel Manager Hotel Mapping Configuration -->
            <div v-if="this.field.displayType == 'channelManagerHotelConfig'">
                <ies-input-channelmanagerhotelconfig :field="this.field"></ies-input-channelmanagerhotelconfig>
            </div>

            <!-- Status Code -->
            <div v-if="this.field.displayType == 'statuskey'">
                <ies-input-statuskey :field="this.field"></ies-input-statuskey>
            </div>

            <!-- Message Class -->
            <div v-if="this.field.displayType == 'messageclass'">
                <ies-input-messageclass :field="this.field"></ies-input-messageclass>
            </div>

            <!-- Message Template -->
            <div v-if="this.field.displayType == 'messageTemplate'" >
                <ies-input-message-template :field="this.field"></ies-input-message-template>
            </div>

            <!-- Sender Type -->
            <div v-if="this.field.displayType == 'sender'">
                <ies-input-sendertype :field="this.field"></ies-input-sendertype>
            </div>

            <!-- Currency Key -->
            <div v-if="this.field.displayType == 'currencyKey'">
                <ies-input-currency-key :field="this.field"></ies-input-currency-key>
            </div>
			
			<!-- VAN Key -->
            <div v-if="this.field.displayType == 'vanKey'" >
                <ies-input-van-key :field="this.field"></ies-input-van-key>
            </div>

            <!-- Airport Transfer Type -->
            <div v-if="this.field.displayType == 'transferType'">
                <ies-input-airport-transfer-type :field="this.field"></ies-input-airport-transfer-type>
            </div>


            <!-- Billing Type -->
            <div v-if="this.field.displayType == 'billingType'">
                <ies-input-billing-type :field="this.field"></ies-input-billing-type>
            </div>

            <!-- Booking System -->
            <div v-if="this.field.displayType == 'bookingSystem'">
                <ies-input-booking-system :field="this.field" :recordData="this.recordData"></ies-input-booking-system>
            </div>

			<!-- User Association Type -->
            <div v-if="this.field.displayType == 'userAssociationType'" >
                <ies-input-user-association-type :field="this.field"></ies-input-user-association-type>
            </div>

            <!-- Channel Manager Names -->
            <div v-if="this.field.displayType == 'channelManagerNames'">
                <ies-input-channel-manager-names :field="this.field"></ies-input-channel-manager-names>
            </div>

            <!-- Deposit Required -->
            <div v-if="this.field.displayType == 'depositRequired'">
                <ies-input-deposit-required :field="this.field" :recordData="this.recordData"></ies-input-deposit-required>
            </div>


            <!-- Channel Manager Region -->
            <div v-if="this.field.displayType == 'channelManagerRegion'">
                <ies-input-channel-manager-region :field="this.field"></ies-input-channel-manager-region>
            </div>

			<!-- Car Hire Type -->
			<div v-if="this.field.displayType == 'carHireType'">
				<ies-input-car-hire-type :field="this.field"></ies-input-car-hire-type>
			</div>

			<!-- Google Map Settings -->
			<div v-if="this.field.displayType == 'googleMapSettings'">
				<ies-input-google-map-settings :field="this.field"></ies-input-google-map-settings>
			</div>

			<!-- Location Type -->
            <div v-if="this.field.displayType == 'locationType'" >
                <ies-input-location-type :field="this.field"></ies-input-location-type>
            </div>

			<!-- General Child Policy -->
            <div v-if="this.field.displayType == 'childPolicy'" >
                <ies-input-child-policy :field="this.field" :recordData="this.recordData"></ies-input-child-policy>
            </div>

			<!-- Age Ranges -->
            <div v-if="this.field.displayType == 'ageRanges'" >
                <ies-input-age-ranges :field="this.field" :recordData="this.recordData"></ies-input-age-ranges>
            </div>

			<!-- Best For Kids -->
            <div v-if="this.field.displayType == 'bestForKids'" >
                <ies-input-best-for-kids :field="this.field" :recordData="this.recordData"></ies-input-best-for-kids>
            </div>

			<!-- Price Ranges -->
            <div v-if="this.field.displayType == 'priceRanges'" >
                <ies-input-price-ranges :field="this.field" :recordData="this.recordData"></ies-input-price-ranges>
            </div>

			<!-- Preset True -->
            <div v-if="this.field.displayType == 'presetTrue'" >
                <ies-input-preset-true :field="this.field" :recordData="this.recordData"></ies-input-preset-true>
            </div>

			<!-- Group Sizes -->
            <div v-if="this.field.displayType == 'groupSizes'" >
                <ies-input-group-size :field="this.field" :recordData="this.recordData"></ies-input-group-size>
            </div>

			<!-- Display Status Type -->
            <div v-if="this.field.displayType == 'displayStatusType'" >
                <ies-input-display-status-type :field="this.field"></ies-input-display-status-type>
            </div>

			<!-- Hotel Reviewers -->
			<div v-if="this.field.displayType == 'hotelReviewers'" >
                <ies-input-hotel-reviewers :field="this.field" :recordData="this.recordData"></ies-input-hotel-reviewers>
            </div>

			<!-- Travel Operator Key -->
			<div v-if="this.field.displayType == 'travelOperatorKey'" >
                <ies-input-travel-operator-key :field="this.field"></ies-input-travel-operator-key>
            </div>

			<!-- Extra Beds -->
			<div v-if="this.field.displayType == 'extraBeds'" >
                <ies-input-extra-beds :field="this.field" :recordData="this.recordData" :page="this.page"></ies-input-extra-beds>
            </div>

            <!-- Trip Itinerary Items -->
            <div v-if="this.field.displayType == 'tripItineraryItems'">
                <ies-input-trip-itinerary-items :field="this.field" :recordData="this.recordData" :page="this.page"></ies-input-trip-itinerary-items>
            </div>

            <!-- Trip Inclusions -->
            <div v-if="this.field.displayType == 'tripInclusions'">
                <ies-input-trip-inclusions :field="this.field" :recordData="this.recordData" :page="this.page"></ies-input-trip-inclusions>
            </div>

			<!-- Is Stay Restricted -->
			<div v-if="this.field.displayType == 'isStayRestricted'" >
                <ies-input-is-stay-restricted :field="this.field" :page="this.page"></ies-input-is-stay-restricted>
            </div>

			<!-- Is Booking Restricted -->
			<div v-if="this.field.displayType == 'isBookingRestricted'" >
                <ies-input-is-booking-restricted :field="this.field" :page="this.page"></ies-input-is-booking-restricted>
			</div>

            <!-- Trip Categories -->
            <div v-if="this.field.displayType == 'tripCategories'">
                <ies-input-trip-categories :field="this.field" :recordData="this.recordData" :page="this.page"></ies-input-trip-categories>
            </div>

            <!-- Trip Activities -->
            <div v-if="this.field.displayType == 'tripActivities'">
                <ies-input-trip-activities :field="this.field" :recordData="this.recordData" :page="this.page"></ies-input-trip-activities>
            </div>

            <!-- Trip Last Display Change -->
            <div v-if="this.field.displayType == 'tripLastDisplayChange'">
                <ies-input-trip-last-display-change :field="this.field" :recordData="this.recordData" :page="this.page"></ies-input-trip-last-display-change>
            </div>

            <!-- Rate Basis -->
            <div v-if="this.field.displayType == 'rateBasis'">
                <ies-input-rate-basis :field="this.field"></ies-input-rate-basis>
            </div>

            <!-- Ratings -->
            <div v-if="this.field.displayType == 'ratings'">
                <ies-input-ratings :field="this.field"></ies-input-ratings>
            </div>
			<!-- Board Basis Key -->
			<div v-if="this.field.displayType == 'boardBasisKey'" >
                <ies-input-board-basis-key :field="this.field"></ies-input-board-basis-key>
            </div>

			<!-- Rate Type Payment Policy Key -->
			<div v-if="this.field.displayType == 'rateTypePaymentPolicyKey'" >
                <ies-input-rate-type-payment-policy-key :field="this.field" :page="this.page"></ies-input-rate-type-payment-policy-key>
            </div>

			<!-- Rate Type Cancellation Policy Key -->
			<div v-if="this.field.displayType == 'rateTypeCancellationPolicyKey'" >
                <ies-input-rate-type-cancellation-policy-key :field="this.field" :page="this.page"></ies-input-rate-type-cancellation-policy-key>
            </div>

			<!-- Rate Type Room Restriction -->
			<div v-if="this.field.displayType == 'rateTypeRoomRestriction'" >
                <ies-input-rate-type-room-restriction :field="this.field" :page="this.page"></ies-input-rate-type-room-restriction>
            </div>

            <!-- Visit Type -->
            <div v-if="this.field.displayType == 'setVisitType'">
                <ies-input-visit-type :field="this.field"></ies-input-visit-type>
            </div>

			<!-- Send Status -->
            <div v-if="this.field.displayType == 'sendStatus'" >
                <ies-input-send-status :field="this.field"></ies-input-send-status>
            </div>

            <!-- Voucher Type -->
            <div v-if="this.field.displayType == 'voucherType'">
                <ies-input-vouchertype :field="this.field"></ies-input-vouchertype>
            </div>

            <!-- Personal Details Key -->
            <div v-if="this.field.displayType == 'personalDetailsKey'">
                <ies-input-personaldetailskey :field="this.field"></ies-input-personaldetailskey>
            </div>

            <!-- Voucher Source Page -->
            <div v-if="this.field.displayType == 'voucherSourcePage'">
                <ies-input-vouchersourcepage :field="this.field"></ies-input-vouchersourcepage>
            </div>

            <!-- Send Digital Voucher -->
            <div v-if="this.field.displayType == 'sendVoucher'">
                <ies-input-sendvoucher :field="this.field"></ies-input-sendvoucher>
            </div>

            <!-- Voucher Creation Purpose -->
            <div v-if="this.field.displayType == 'voucherCreationPurpose'">
                <ies-input-vouchercreationpurpose :field="this.field"></ies-input-vouchercreationpurpose>
            </div>

            <!-- Payment Request Status -->
            <div v-if="this.field.displayType == 'paymentRequestStatus'" >
                <ies-input-paymentrequeststatus :field="this.field"></ies-input-paymentrequeststatus>
            </div>

            <!-- Payment Request Reason -->
            <div v-if="this.field.displayType == 'PaymentRequestReason'" >
                <ies-input-payment-request-reason :field="this.field" :recordData="this.recordData"></ies-input-payment-request-reason>
            </div>

            <!-- Payment service provider -->
            <div v-if="this.field.displayType == 'paymentProviderKey'">
                <ies-input-paymentproviderkey :field="this.field"></ies-input-paymentproviderkey>
            </div>

            <!-- VAN service provider -->
            <div v-if="this.field.displayType == 'vanProviderKey'">
                <ies-input-vanproviderkey :field="this.field"></ies-input-vanproviderkey>
            </div>

            <!-- Payment orchestration action -->
            <div v-if="this.field.displayType == 'paymentAction'">
                <ies-input-paymentaction :field="this.field"></ies-input-paymentaction>
            </div>

            <!-- Dashboard -->
            <div v-if="this.field.displayType == 'dashboardKey'">
                <ies-input-dashboardkey :field="this.field"></ies-input-dashboardkey>
            </div>

            <!-- Dashboard Panel -->
            <div v-if="this.field.displayType == 'dashboardPanelKey'">
                <ies-input-dashboardpanelkey :field="this.field"></ies-input-dashboardpanelkey>
            </div>

            <div v-if="this.field.displayType == 'adminUserKey'">
                <ies-input-adminuserkey :field="this.field"></ies-input-adminuserkey>
            </div>

            <div v-if="this.field.displayType == 'adminDepartmentKey'">
                <ies-input-admindepartmentkey :field="this.field"></ies-input-admindepartmentkey>
            </div>

            <div v-if="this.field.displayType == 'adminRoleKey'">
                <ies-input-adminrolekey :field="this.field"></ies-input-adminrolekey>
            </div>

            <!-- Quick Menu Link -->
            <div v-if="this.field.displayType == 'quickMenuLink'">
                <ies-input-quickmenulink :field="this.field"></ies-input-quickmenulink>
            </div>

            <!-- Portal Content Type -->
            <div v-if="this.field.displayType == 'portalContentTypeKey'">
                <ies-input-portalcontenttypekey :field="this.field"></ies-input-portalcontenttypekey>
            </div>

            <!-- Photo -->
            <div v-if="this.field.displayType == 'image'">
                <ies-input-image :field="this.field"></ies-input-image>
            </div>

            <!-- Check box -->
            <div v-if="this.field.displayType == 'checkbox'">
                <ies-input-checkbox :field="this.field"></ies-input-checkbox>
            </div>

            <!-- Switch -->
            <div v-if="this.field.displayType == 'switch' || this.field.displayType == 'switch_green' || this.field.displayType == 'switch_blue' || this.field.displayType == 'switch_red'">
                <ies-input-switch :field="this.field" :color="this.field.displayType" label="true"></ies-input-switch>
            </div>

            <!-- Date -->
            <div v-if="this.field.displayType == 'date'">
                <ies-input-date :field="this.field"></ies-input-date>
            </div>

            <!-- Time -->
            <div v-if="this.field.displayType == 'time'">
                <ies-input-time :field="this.field"></ies-input-time>
            </div>

            <!-- Datetime -->
            <div v-if="this.field.displayType == 'datetime'">
                <ies-input-datetime :field="this.field"></ies-input-datetime>
            </div>

            <!-- Select box -->
            <div v-if="this.field.displayType == 'select'">
                <ies-input-select :field="this.field"></ies-input-select>
            </div>

            <!-- Day of Week (bitwise) -->
            <div v-if="this.field.displayType == 'dayOfWeek'">
                <ies-input-weekday :field="this.field"></ies-input-weekday>
            </div>

            <!-- Months of Year (bitwise) -->
            <div v-if="this.field.displayType == 'monthsOfYear'">
                <ies-input-months-of-year :field="this.field"></ies-input-months-of-year>
            </div>

            <div v-if="this.field.displayType == 'iCalFeedType'">
                <ies-ical-feed-type :field="this.field"></ies-ical-feed-type>
            </div>

            <div v-if="this.field.displayType == 'newsletter_subscriptions'">
                <ies-newsletter-subscriptions :field="this.field"></ies-newsletter-subscriptions>
            </div>

            <!-- radio button -->

            <!-- Map -->

            <!-- Password  -->
            <div v-if="this.field.displayType == 'password'">
                <ies-input-password :field="this.field"></ies-input-password>
            </div>

            <div v-if="this.field.displayType == 'UserAssociations'">
                <ies-input-user-associations :field="this.field"></ies-input-user-associations>
            </div>

            <div v-if="this.field.displayType == 'telephones'">
                <ies-input-telephone-numbers :field="this.field" :recordData="this.recordData"></ies-input-telephone-numbers>
            </div>

            <!-- Custom -->
            <div v-if="this.field.displayType == 'custom'">

				<!-- Blog Regions -->
				<div v-if="this.field.customComponent == 'blogRegions'">
					<ies-input-blogregions :field="this.field" :recordData="this.recordData"></ies-input-blogregions>
				</div>

                <!-- Exclude any component name if there is a discrepancy between the name of the component and what is actually registered with VueJS, until we can get them to match again -->
<!--
                <component  :is="this.field.customComponent" :field="this.field" :recordData="this.recordData" ></component>
-->
<!--
.{{ this.field.customComponent }}.
                <div v-if="this.field.customComponent == 'PaymentRequestReason'">***
                    <ies-input-payment-request-reason :field="this.field" :recordData="this.recordData"></ies-input-payment-request-reason>
                </div>
-->
            </div>


            <!-- Append HTML -->
            <div v-if="this.field.appendHtml != ''">
                {{ this.field.appendHtml }}
            </div>

            <!-- TinyMCE editor -->
            <div v-if="this.field.displayType == 'tinymce'">
                <ies-input-tinymce :field="this.field"></ies-input-tinymce>
            </div>

            <!-- Mime Type -->
            <div v-if="this.field.displayType == 'mimeType'">
                <ies-input-mime-type :field="this.field"></ies-input-mime-type>
            </div>

            <div v-if="this.field.displayType == 'additionalFeePayee'">
                <ies-input-additional-fee-payee :field="this.field"></ies-input-additional-fee-payee>
            </div>
            <div v-if="this.field.displayType == 'additionalFeeCategory'">
                <ies-input-additional-fee-category :field="this.field"></ies-input-additional-fee-category>
            </div>
            <div v-if="this.field.displayType == 'additionalFeeApplication'">
                <ies-input-additional-fee-application :field="this.field"></ies-input-additional-fee-application>
            </div>

        <div v-if="field.outroduction">{{ field.outroduction }}</div>
    </div>
</template>
<script>

var disabledInput = require("./Disabled.vue").default;
var textInput     = require("./Text.vue").default;
var textareaInput = require("./Textarea.vue").default;
var integerInput  = require("./Integer.vue").default;
var imageInput    = require("./Image.vue").default;
var checkboxInput = require("./Checkbox.vue").default;
var emailInput    = require("./Email.vue").default;
var facilityKeyInput = require("./FacilityKey.vue").default;
var displayGroupInput = require("./HotelFacilityDisplayGroup.vue").default;
var additionalFKeyInput = require("./HotelKey.vue").default;
var hotelKeyInput = require("./HotelKey.vue").default;
var feePayeeInput = require("./AdditionalFeePayee.vue").default;
var feeCategoryInput = require("./AdditionalFeeCategory.vue").default;
var feeApplicationInput = require("./AdditionalFeeApplication.vue").default;
var portalContentTypeKeyInput = require("./PortalContentTypeKey.vue").default;
var countryKeyInput = require("./CountryKey.vue").default;
var regionKeyInput = require("./RegionKey.vue").default;
var channelManagerKeyInput = require("./ChannelManagerKey.vue").default;
var channelManagerConfigInput = require("./ChannelManagerConfig.vue").default;
var channelManagerHotelConfigInput = require("./ChannelManagerHotelConfig.vue").default;
var statusKeyInput = require("./StatusKey.vue").default;
var dayOfWeekInput = require("./DayOfWeek.vue").default;
var monthsOfYearInput = require("./MonthsOfYear.vue").default;
var iCalFeedTypeInput = require("./ICalFeedType.vue").default;
var messageClassInput = require("./MessageClass.vue").default;
var paymentActionInput = require("./PaymentAction.vue").default;
var paymentProviderInput = require("./PaymentProviderKey.vue").default;
var vanProviderInput = require("./VanProviderKey.vue").default;
var messagingInput = require("./MessageTemplate.vue").default;
var sendStatusInput = require("./SendStatus.vue").default;
var senderTypeInput = require("./SenderType.vue").default;
var currencyKey = require("./CurrencyKey.vue").default;
var virtualCreditCardKey = require("./VanKey.vue").default;
var airportTransferTypeInput = require("./AirportTransferType.vue").default;
var userAssociationType = require("./UserAssociationType.vue").default;
var telephoneNumbers = require("./TelephoneNumbers.vue").default;
var billingType = require("./BillingType.vue").default;
var bookingSystem = require("./BookingSystem.vue").default;
var channelManagerNames = require("./ChannelManagerNames.vue").default;
var depositRequired = require("./DepositRequired.vue").default;
var carHireTypeInput = require("./CarHireType.vue").default;
var channelManagerRegion = require("./ChannelManagerRegion.vue").default;
var googleMapSettings = require("./GoogleMap.vue").default;
var hotelReviewers = require("./HotelReviewers.vue").default;
var locationType = require("./LocationType.vue").default;
var childPolicy = require("./ChildPolicy.vue").default;
var ageRanges = require("./AgeRanges.vue").default;
var bestForKids = require("./BestForKids.vue").default;
var priceRanges = require("./PriceRange.vue").default;
var presetTrue = require("./PresetTrue.vue").default;
var groupSizes = require("./GroupSize.vue").default;
var displayStatusType = require("./DisplayStatusType.vue").default;
var travelOperatorKey = require("./TravelOperatorKey.vue").default;
var extraBeds = require("./ExtraBeds.vue").default;
var tripItineraryItems = require("./TripItineraryItems.vue").default;
var tripInclusions = require("./TripInclusions.vue").default;
var tripCategories = require("./TripCategories.vue").default;
var tripActivities = require("./TripActivities.vue").default;
var tripLastDisplayChange = require("./TripLastDisplayChange.vue").default;
var rateBasis = require("./RateBasisPer.vue").default;
var boardBasisKey = require("./BoardBasisKey.vue").default;
var rateTypePaymentPolicyKey = require("./RateTypePaymentPolicy.vue").default;
var rateTypeCancellationPolicyKey = require("./RateTypeCancellationPolicy.vue").default;
var rateTypeRoomRestriction = require("./RateTypeRoomRestriction.vue").default;
var isStayRestricted = require("./IsStayRestricted.vue").default;
var isBookingRestricted = require("./IsBookingRestricted.vue").default;
var ratings = require("./Ratings.vue").default;
var setVisitType = require("./SetVisitType.vue").default;
var voucherTypeInput = require("./VoucherType.vue").default;
var personalDetailsKeyInput = require("./PersonalDetailsKey.vue").default;
var sendVoucherInput = require("./ResendVoucher.vue").default;
var voucherPurposeInput = require("./VoucherCreationPurpose.vue").default;
var voucherSourcePageInput = require("./VoucherSourcePage.vue").default;
var paymentRequestStatusInput = require("./PaymentRequestStatus.vue").default;
var paymentRequestReasonInput = require("./PaymentRequestReason.vue").default;
var dashboardKeyInput = require("./DashboardKey.vue").default;
var dashboardPanelKeyInput = require("./DashboardPanelKey.vue").default;
var blogRegionsInput = require("./BlogRegions.vue").default;
var quickMenuLinkInput = require("./QuickMenuLink.vue").default;
var adminUserInput = require("./AdminUserKey.vue").default;
var adminDepartmentInput = require("./AdminDepartmentKey.vue").default;
var adminRoleInput = require("./AdminRoleKey.vue").default;
var dateInput     = require("./Date.vue").default;
var timeInput     = require("./Time.vue").default;
var datetimeInput = require("./Datetime.vue").default;
var passwordInput = require("./Password.vue").default;
var tinymceInput  = require("./TinyMCE.vue").default;
var switchInput   = require("./Switch.vue").default;
var select        = require("./Select.vue").default;
var htmlinput     = require("./HTMLinput.vue").default;
var facilityCategoriesInput = require("./FacilityCategories.vue").default;
var hotelRoomTypeKeyInput = require("./HotelRoomTypeKey.vue").default;
var rateTypeKeyInput = require("./RateTypeKey.vue").default;
var regionHierarchyInput = require("./RegionHierarchy.vue").default;
var newsletterSubscriptionsInput = require("./NewsletterSubscriptions.vue").default;
var keywordKeyInput = require("./KeywordKey.vue").default;
var userAssocInput = require("./UserAssociations.vue").default;
var mimeTypeInput = require("./MimeType.vue").default;


export default {
    name: 'ies-input',
    props: ['field', 'recordData', 'page'],
    data () {
        return {
        }
    },
    components: {
        'ies-input-disabled' : disabledInput,
        'ies-input-text'     : textInput,
        'ies-input-textarea' : textareaInput,
        'ies-input-integer'  : integerInput,
        'ies-input-image'    : imageInput,
        'ies-input-checkbox' : checkboxInput,
        'ies-input-email'    : emailInput,
        'ies-input-date'     : dateInput,
        'ies-input-time'     : timeInput,
        'ies-input-datetime' : datetimeInput,
        'ies-input-password' : passwordInput,
        'ies-input-tinymce'  : tinymceInput,
        'ies-input-switch'   : switchInput,
        'ies-input-select'   : select,
        'ies-input-htmlinput': htmlinput,
        'ies-input-displaygroup' : displayGroupInput,
        'ies-input-facilitycategories' : facilityCategoriesInput,
        'ies-input-facilitykey' : facilityKeyInput,
        'ies-input-hotelkey' : hotelKeyInput,
        'ies-input-additional-fee-payee' : feePayeeInput,
        'ies-input-additional-fee-category' : feeCategoryInput,
        'ies-input-additional-fee-application' : feeApplicationInput,
        'ies-input-hotelroomtypekey' : hotelRoomTypeKeyInput,
        'ies-input-keyword' : keywordKeyInput,
        'ies-input-ratetypekey' : rateTypeKeyInput,
        'ies-input-countrykey': countryKeyInput,
        'ies-input-regionkey': regionKeyInput,
        'ies-input-regionhierarchy': regionHierarchyInput,
        'ies-input-channelmanagerkey': channelManagerKeyInput,
        'ies-input-channelmanagerconfig': channelManagerConfigInput,
        'ies-input-channelmanagerhotelconfig': channelManagerHotelConfigInput,
        'ies-input-statuskey': statusKeyInput,
        'ies-input-weekday': dayOfWeekInput,
        'ies-input-months-of-year': monthsOfYearInput,
        'ies-ical-feed-type': iCalFeedTypeInput,
        'ies-input-messageclass': messageClassInput,
        'ies-input-adminuserkey': adminUserInput,
        'ies-input-admindepartmentkey': adminDepartmentInput,
        'ies-input-adminrolekey': adminRoleInput,
        'ies-input-paymentaction': paymentActionInput,
        'ies-input-paymentproviderkey': paymentProviderInput,
        'ies-input-vanproviderkey': vanProviderInput,
        'ies-input-sendertype': senderTypeInput,
		'ies-input-currency-key': currencyKey,
		'ies-input-van-key': virtualCreditCardKey,
        'ies-input-message-template': messagingInput,
        'ies-input-send-status': sendStatusInput,
		'ies-input-airport-transfer-type': airportTransferTypeInput,
		'ies-input-user-association-type': userAssociationType,
		'ies-input-telephone-numbers': telephoneNumbers,
		'ies-input-billing-type': billingType,
		'ies-input-booking-system': bookingSystem,
		'ies-input-channel-manager-names': channelManagerNames,
		'ies-input-deposit-required': depositRequired,
		'ies-input-channel-manager-region': channelManagerRegion,
		'ies-input-car-hire-type': carHireTypeInput,
		'ies-input-google-map-settings': googleMapSettings,
		'ies-input-hotel-reviewers': hotelReviewers,
		'ies-input-ratings': ratings, 
		'ies-input-visit-type': setVisitType, 
		'ies-input-location-type': locationType,
		'ies-input-child-policy': childPolicy,
		'ies-input-age-ranges': ageRanges,
		'ies-input-best-for-kids': bestForKids,
		'ies-input-price-ranges': priceRanges,
		'ies-input-preset-true': presetTrue,
		'ies-input-group-size': groupSizes,
		'ies-input-display-status-type': displayStatusType,
		'ies-input-travel-operator-key': travelOperatorKey,
		'ies-input-extra-beds': extraBeds,
		'ies-input-trip-itinerary-items': tripItineraryItems,
		'ies-input-trip-inclusions': tripInclusions,
		'ies-input-trip-categories': tripCategories,
		'ies-input-trip-activities': tripActivities,
		'ies-input-trip-last-display-change': tripLastDisplayChange,
		'ies-input-rate-basis': rateBasis,
		'ies-input-board-basis-key': boardBasisKey,
		'ies-input-rate-type-payment-policy-key': rateTypePaymentPolicyKey,
        'ies-input-rate-type-cancellation-policy-key': rateTypeCancellationPolicyKey,
        'ies-input-rate-type-room-restriction': rateTypeRoomRestriction,
        'ies-input-is-stay-restricted': isStayRestricted,
        'ies-input-is-booking-restricted': isBookingRestricted,
        'ies-input-vouchertype': voucherTypeInput,
        'ies-input-personaldetailskey': personalDetailsKeyInput,
        'ies-input-sendvoucher': sendVoucherInput,
        'ies-input-vouchersourcepage': voucherSourcePageInput,
        'ies-input-vouchercreationpurpose': voucherPurposeInput,
        'ies-input-paymentrequeststatus': paymentRequestStatusInput,
        'ies-input-payment-request-reason': paymentRequestReasonInput,
        'ies-input-dashboardkey': dashboardKeyInput,
        'ies-input-dashboardpanelkey': dashboardPanelKeyInput,
        'ies-input-blogregions': blogRegionsInput,
        'ies-input-quickmenulink': quickMenuLinkInput,
        'ies-input-portalcontenttypekey': portalContentTypeKeyInput,
        'ies-newsletter-subscriptions': newsletterSubscriptionsInput,
        'ies-input-user-associations': userAssocInput,
        'ies-input-mime-type': mimeTypeInput,
    },
    created: function(){
//        this.getCustomComponent()
    },
    methods: {
/*
        getCustomComponent: function(){
            
            if(this.field.displayType == "custom"){
                var component = require("/" + this.field.customComponent+".vue");
                Vue.component(this.field.customComponent, component);
            }
            
            console.log("Adding custom component: ", this.field.customComponent+".vue");
        }
*/
    }
}
</script>


